"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateInput = DateInput;
var React = _interopRequireWildcard(require("react"));
var _AdapterDayjs = require("@mui/x-date-pickers/AdapterDayjs");
var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _DatePicker = require("@mui/x-date-pickers/DatePicker");
var _reactHookForm = require("react-hook-form");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function DateInput({
  control,
  field,
  errors
}) {
  const hasError = Boolean(errors) && Boolean(errors[field]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_LocalizationProvider.LocalizationProvider, {
    dateAdapter: _AdapterDayjs.AdapterDayjs
  }, /*#__PURE__*/React.createElement(_reactHookForm.Controller, {
    name: field,
    control: control,
    render: ({
      field: {
        onChange: handleChange,
        value = null,
        ...rest
      },
      fieldState: {
        error,
        invalid
      }
    }) => {
      return /*#__PURE__*/React.createElement(_DatePicker.DatePicker, {
        value: value,
        onChange: handleChange,
        slotProps: {
          textField: {
            helperText: hasError ? errors.date?.message : null,
            error: invalid
          }
        }
      });
    }
  })));
}